import { UntypedFormGroup } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-confirm-button-combo',
  templateUrl: './confirm-button-combo.component.html',
  styleUrls: ['./confirm-button-combo.component.css']
})
export class ConfirmButtonComboComponent implements OnInit {
  @Input() baseLabel = '';
  @Input() commit_btn_spinner = '';
  @Input() formGroup: UntypedFormGroup;
  @Input() addSpacer = true;
  @Input() addSyncFixed = true;
  @Output() confirmSelected: EventEmitter<boolean> = new EventEmitter();
  @Output() baseButtonClicked: EventEmitter<boolean> = new EventEmitter();

  buttonLabel: string;
  showCancelButton = false;
  confirmLabel = ' CONFIRM ';

  constructor() {}

  ngOnInit() {
    this.buttonLabel = this.baseLabel;
  }

  baseButtonClick() {
    if (this.buttonLabel === this.confirmLabel) {
      this.showCancelButton = false;
      this.buttonLabel = this.baseLabel;
      this.confirmSelected.emit(true);
    } else {
      let fieldsValid = true;
      if (this.formGroup) {
        Object.keys(this.formGroup.controls).forEach(field => {
          const control = this.formGroup.get(field);
          if (control.invalid) {
            // Checking if form valid was not working
            fieldsValid = false;
          }
        });
      }
      if (fieldsValid) {
        this.showCancelButton = true;
        this.buttonLabel = this.confirmLabel;
      }
      this.baseButtonClicked.emit(true);
    }
  }

  cancelButtonClick() {
    this.showCancelButton = false;
    this.buttonLabel = this.baseLabel;
  }
}
